import { useState } from 'react';
import { useTranslation } from '../../i18n';

const TABS = ['search', 'relationships', 'reports', 'export'];

// TODO(api): replace with GET /api/v1/relationships.
const MOCK_RELATIONSHIPS = [
  { partner: 'UNESCO',           lastMentioned: '2026-04-12', count: 14 },
  { partner: 'Europa Nostra',    lastMentioned: '2026-03-28', count: 9  },
  { partner: 'MKiDN',            lastMentioned: '2026-04-02', count: 7  },
  { partner: 'European Commission', lastMentioned: '2026-02-15', count: 4 },
];

export function KnowledgeSearch() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('search');
  const [query, setQuery] = useState('');

  return (
    <div>
      <header className="page-header">
        <h1 className="page-header__title">{t('knowledge.title')}</h1>
        <div className="page-header__subtitle">{t('knowledge.subtitle')}</div>
      </header>

      <div className="kb-search">
        <span className="kb-search__icon" aria-hidden="true">🔍</span>
        <input
          type="text"
          value={query}
          placeholder={t('knowledge.searchPlaceholder')}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      <div className="tabs" role="tablist">
        {TABS.map((key) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            className={'tab' + (tab === key ? ' tab--active' : '')}
            onClick={() => setTab(key)}
          >
            {t(`knowledge.tabs.${key}`)}
          </button>
        ))}
      </div>

      {tab === 'search' && (
        <div className="empty-state">
          <div className="empty-state__icon" aria-hidden="true">🔎</div>
          <p>{t('knowledge.search.hint')}</p>
        </div>
      )}

      {tab === 'relationships' && (
        <div>
          <p className="page-header__subtitle" style={{ marginBottom: 'var(--space-3)' }}>
            {t('knowledge.relationships.intro')}
          </p>
          <table className="data-table">
            <thead>
              <tr>
                <th>{t('knowledge.relationships.partner')}</th>
                <th>{t('knowledge.relationships.lastMentioned')}</th>
                <th>{t('knowledge.relationships.mentionCount')}</th>
              </tr>
            </thead>
            <tbody>
              {MOCK_RELATIONSHIPS.map((row) => (
                <tr key={row.partner}>
                  <td><strong>{row.partner}</strong></td>
                  <td><span className="mono">{row.lastMentioned}</span></td>
                  <td>{row.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {tab === 'reports' && (
        <div>
          <p className="page-header__subtitle" style={{ marginBottom: 'var(--space-3)' }}>
            {t('knowledge.reports.intro')}
          </p>
          <div className="kb-cta">
            <div className="kb-cta__body">
              <h3 className="kb-cta__title">{t('knowledge.reports.annualTitle')}</h3>
              <div className="kb-cta__hint">{t('knowledge.reports.annualHint')}</div>
            </div>
            <button type="button" className="button button--primary">
              {t('knowledge.reports.annualButton')}
            </button>
          </div>
          <div className="kb-cta">
            <div className="kb-cta__body">
              <h3 className="kb-cta__title">{t('knowledge.reports.onboardingTitle')}</h3>
              <div className="kb-cta__hint">{t('knowledge.reports.onboardingHint')}</div>
            </div>
            <button type="button" className="button button--primary">
              {t('knowledge.reports.onboardingButton')}
            </button>
          </div>
        </div>
      )}

      {tab === 'export' && (
        <div className="kb-cta">
          <div className="kb-cta__body">
            <h3 className="kb-cta__title">{t('knowledge.export.title')}</h3>
            <div className="kb-cta__hint">{t('knowledge.export.hint')}</div>
          </div>
          <button type="button" className="button button--primary">
            ⬇ {t('knowledge.export.button')}
          </button>
        </div>
      )}
    </div>
  );
}
